import { CENTRAL_API_BASE_URL_V2 } from '../../constants/central-api';

/* ----------ACTIONS - PROPOSALS ENDPOINTS----------- */
export const ACTION_PROPOSALS_URL = () =>
  `${CENTRAL_API_BASE_URL_V2}tara/actions/proposals`;

export const SHOP_ACTION_PROPOSALS_URL = (shopSlug: string) =>
  `${CENTRAL_API_BASE_URL_V2}tara/shops/${shopSlug}/actions/proposals`;

export const SHOP_ACTION_PROPOSAL_URL = (
  shopSlug: string,
  proposalId: string
) =>
  `${CENTRAL_API_BASE_URL_V2}tara/shops/${shopSlug}/actions/proposals/${proposalId}`;

export const APPROVE_PROPOSAL_URL = (
  shopSlug: string,
  proposalId: string
) =>
  `${CENTRAL_API_BASE_URL_V2}tara/shops/${shopSlug}/actions/proposals/${proposalId}/approve`;

export const DENY_PROPOSAL_URL = (shopSlug: string, proposalId: string) =>
  `${CENTRAL_API_BASE_URL_V2}tara/shops/${shopSlug}/actions/proposals/${proposalId}/deny`;

/* ----------ACTIONS - SETTINGS ENDPOINTS----------- */
export const ACTION_SETTINGS_URL = (shopSlug: string) =>
  `${CENTRAL_API_BASE_URL_V2}tara/shops/${shopSlug}/actions/settings`;

/* ----------ACTIONS - RULES ENDPOINTS----------- */
export const ACTION_RULES_URL = (shopSlug: string) =>
  `${CENTRAL_API_BASE_URL_V2}tara/shops/${shopSlug}/actions/rules`;

export const ACTION_RULE_URL = (shopSlug: string, ruleId: string) =>
  `${CENTRAL_API_BASE_URL_V2}tara/shops/${shopSlug}/actions/rules/${ruleId}`;

/* ----------ACTIONS - AUDIT LOG ENDPOINTS----------- */
export const ACTION_AUDIT_LOG_URL = (shopSlug: string) =>
  `${CENTRAL_API_BASE_URL_V2}tara/shops/${shopSlug}/actions/audit-log`;
